export default "__VITE_ASSET__DakXKRta__"